module.exports = __webpack_public_path__ + "static/media/bkg03n.dcbf4d24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg03n.jpg
// module id = 468
// module chunks = 0